import axios from 'smg/axios';
import * as buttons from 'smg/buttons';
import * as countries from 'smg/countries';
import * as paymentmethods from 'smg/customer-api/paymentoptions';
import * as session from 'smg/customer-api/session';
import * as shippingoptions from 'smg/customer-api/shippingoptions';
import * as errors from 'smg/errors';
import { ReportValidity } from 'smg/form';
import * as models from 'smg/models';
import { Phone } from 'smg/phone';
import * as template from 'smg/template';
import * as toast from 'smg/toast';
import { Relref } from '../hugo';
import { PromptNewPaymentOption } from '../payments';
import * as shippingFunctions from '../shippingoptions';

export default async function main() {
    if (await session.Redirect(undefined, Relref('/login'))) {
        return;
    }

    const sess = await session.Session();

    // PROFILE & EDIT PROFILE

    const fullName = document.querySelector('#user-name') as HTMLElement;
    const email = document.querySelector('#user-email') as HTMLElement;
    const phone = document.querySelector('#user-phone') as HTMLElement;
    const password = document.querySelector('#user-password') as HTMLElement;

    fullName.textContent = `${sess.firstName} ${sess.lastName}`;
    email.textContent = sess.email;
    phone.textContent = sess.phone;
    password.textContent = '***';

    const userProfileForm = document.querySelector('#user-profile-form') as HTMLFormElement;
    const fieldset = userProfileForm.querySelector('fieldset') as HTMLFieldSetElement;

    const saveBtn = document.querySelector('#save-user-profile-btn') as HTMLButtonElement;
    const profileInputs = Array.from(userProfileForm.querySelectorAll('input'));

    const editNameBtn = document.querySelector('#edit-name') as HTMLElement;
    const nameInputs = document.querySelector('#name-inputs-wrap') as HTMLElement;
    const editFirstNameInput = document.querySelector('#edit-first-name-input') as HTMLInputElement;
    const editLastNameInput = document.querySelector('#edit-last-name-input') as HTMLInputElement;
    const cancelNameEdit = document.querySelector('#cancel-name-edit') as HTMLElement;

    const editEmailBtn = document.querySelector('#edit-email') as HTMLElement;
    const emailInput = document.querySelector('#user-email-input-wrap') as HTMLElement;
    const editEmailInput = document.querySelector('#edit-email-input') as HTMLInputElement;
    const cancelEmailEdit = document.querySelector('#cancel-email-edit') as HTMLElement;

    const editPhoneBtn = document.querySelector('#edit-phone') as HTMLElement;
    const phoneInput = document.querySelector('#user-phone-input-wrap') as HTMLElement;
    const editPhoneInput = document.querySelector('#edit-phone-input') as HTMLInputElement;
    const cancelPhoneEdit = document.querySelector('#cancel-phone-edit') as HTMLElement;

    const editPasswordBtn = document.querySelector('#edit-password') as HTMLElement;
    const passwordInputs = document.querySelector('#user-password-inputs-wrap') as HTMLElement;
    const editPasswordInput = document.querySelector('#edit-password-input') as HTMLInputElement;
    const confirmPasswordInput = document.querySelector('#confirm-password-input') as HTMLInputElement;
    const cancelPasswordEdit = document.querySelector('#cancel-password-edit') as HTMLElement;

    const checkOpenEdits = (arr: HTMLInputElement[]) => {
        for (const v of arr) {
            if (v.disabled) {
                continue;
            } else {
                return true;
            }
        }
    };

    const checkConfirm = () => {
        if (editPasswordInput.value === confirmPasswordInput.value) {
            confirmPasswordInput.setCustomValidity('');
        } else {
            confirmPasswordInput.setCustomValidity('Passwords must match');
        }
    };

    const editOrCancelClicked = (btnWasEdit: boolean, staticEl: HTMLElement, inputsContainer: HTMLElement, inputs: HTMLInputElement[], editBtn: HTMLElement, cancelBtn: HTMLElement) => {
        if (btnWasEdit) {
            staticEl.classList.add('d-none');
            inputsContainer.classList.remove('d-none');
            for (const input of inputs) {
                input.disabled = false;
                input.required = true;
            }
            editBtn.classList.add('d-none');
            cancelBtn.classList.remove('d-none');
        } else {
            staticEl.classList.remove('d-none');
            inputsContainer.classList.add('d-none');
            for (const input of inputs) {
                input.value = '';
                input.disabled = true;
                input.required = false;
            }
            editBtn.classList.remove('d-none');
            cancelBtn.classList.add('d-none');

            if (!checkOpenEdits(profileInputs)) {
                saveBtn.classList.add('d-none');
            } else {
                saveBtn.classList.remove('d-none');
            }
        }
    };

    editNameBtn.addEventListener('click', e => {
        e.preventDefault();
        saveBtn.classList.remove('d-none');

        editOrCancelClicked(true, fullName, nameInputs, [editFirstNameInput, editLastNameInput], editNameBtn, cancelNameEdit);
    });

    cancelNameEdit.addEventListener('click', e => {
        e.preventDefault();

        editOrCancelClicked(false, fullName, nameInputs, [editFirstNameInput, editLastNameInput], editNameBtn, cancelNameEdit);
    });

    editEmailBtn.addEventListener('click', e => {
        e.preventDefault();
        saveBtn.classList.remove('d-none');

        editOrCancelClicked(true, email, emailInput, [editEmailInput], editEmailBtn, cancelEmailEdit);
    });

    cancelEmailEdit.addEventListener('click', e => {
        e.preventDefault();

        editOrCancelClicked(false, email, emailInput, [editEmailInput], editEmailBtn, cancelEmailEdit);
    });

    editPhoneBtn.addEventListener('click', e => {
        e.preventDefault();
        saveBtn.classList.remove('d-none');

        editOrCancelClicked(true, phone, phoneInput, [editPhoneInput], editPhoneBtn, cancelPhoneEdit);
    });

    cancelPhoneEdit.addEventListener('click', e => {
        e.preventDefault();

        editOrCancelClicked(false, phone, phoneInput, [editPhoneInput], editPhoneBtn, cancelPhoneEdit);
    });

    editPasswordBtn.addEventListener('click', e => {
        e.preventDefault();
        saveBtn.classList.remove('d-none');

        editOrCancelClicked(true, password, passwordInputs, [editPasswordInput, confirmPasswordInput], editPasswordBtn, cancelPasswordEdit);
    });

    cancelPasswordEdit.addEventListener('click', e => {
        e.preventDefault();

        editOrCancelClicked(false, password, passwordInputs, [editPasswordInput, confirmPasswordInput], editPasswordBtn, cancelPasswordEdit);
    });

    editPasswordInput.addEventListener('input', () => checkConfirm());
    confirmPasswordInput.addEventListener('input', () => checkConfirm());

    const p = new Phone(editPhoneInput);

    userProfileForm.noValidate = true;
    userProfileForm.addEventListener('submit', async e => {
        e.preventDefault();

        if (!ReportValidity(userProfileForm)) {
            const validityMessages = Array.from(userProfileForm.querySelectorAll('.invalid-feedback'));
            for (const validityMessage of validityMessages) {
                validityMessage.classList.add('mt-0');
            }
            if (editFirstNameInput.nextElementSibling?.classList.contains('invalid-feedback')) {
                editFirstNameInput.classList.remove('mb-5');
            }
            if (editPasswordInput.nextElementSibling?.classList.contains('invalid-feedback')) {
                editPasswordInput.classList.remove('mb-5');
            }
            return false;
        }

        fieldset.disabled = true;
        buttons.Start(saveBtn);

        const updatedUser = axios.patch('/current-user', {
            'firstName': editFirstNameInput.disabled ? sess.firstName : editFirstNameInput.value,
            'lastName': editLastNameInput.disabled ? sess.lastName : editLastNameInput.value,
            'company': sess.company,
            'email': editEmailInput.disabled ? sess.email : editEmailInput.value,
            'phone': editPhoneInput.disabled ? sess.phone : await p.Format(),
        });

        let updateUserPassword: Promise<void> | undefined;
        if (!editPasswordInput.disabled && !confirmPasswordInput.disabled) {
            updateUserPassword = axios.patch('/current-user/password', {
                'newPassword': editPasswordInput.value,
                'confirmPassword': confirmPasswordInput.value,
            });
        }

        await Promise.all([updatedUser, updateUserPassword]).then(() => {
            for (const input of profileInputs) {
                input.disabled = true;
            }
            session.ClearCache();
            buttons.Stop(saveBtn);
            toast.Success('Updated Information');
        }).catch(err => errors.HandleRequestError(err, userProfileForm));
    });

    // ADDRESSES
    const shippingOptions = await shippingoptions.GetShippingOptions({
        'data': 'fullName,company,addressLine1,addressLine1,city,stateID,zip,countryID,phone,email',
        'sort': 'created asc',
        'q': 'has:email has:phone has:fullName has:addressLine1 has:city has:countryID has:zip',
    });

    async function drawAddresses(shippingOptions: models.ShippingOption[]) {
        const addressWrap = document.querySelector('#addresses-container') as HTMLElement;

        for (const shippingOption of shippingOptions) {
            const countryID = await countries.GetCountry(shippingOption.countryID || 0);
            const stateID = await countries.GetState(shippingOption.countryID || 0, shippingOption.stateID || 0);

            const templateEl = template.Clone(document.querySelector('#address-template') as HTMLTemplateElement);
            const templateElChild = templateEl.querySelector('#address-elements') as HTMLElement;
            if (shippingOption.company) {
                const company = templateEl.querySelector('#shipping-company') as HTMLElement;
                company.textContent = shippingOption.company;
            }
            const name = templateEl.querySelector('#shipping-name') as HTMLElement;
            const addressLineOne = templateEl.querySelector('#shipping-addressline-one') as HTMLElement;
            const addressLineTwo = templateEl.querySelector('#shipping-addressline-two') as HTMLElement;
            const cityStateZip = templateEl.querySelector('#shipping-city-state-zip') as HTMLElement;
            const city = cityStateZip.querySelector('#shipping-city') as HTMLElement;
            const state = cityStateZip.querySelector('#shipping-state') as HTMLElement;
            const zip = cityStateZip.querySelector('#shipping-zip') as HTMLElement;
            const country = templateEl.querySelector('#shipping-country') as HTMLElement;
            const deleteAddressBtn = templateEl.querySelector('#delete-address') as HTMLElement;

            deleteAddressBtn.addEventListener('click', () => {
                void shippingoptions.DeleteShippingOption(shippingOption.id || '').then(() => {
                    templateElChild.parentElement?.removeChild(templateElChild);
                    toast.Success('Removed Address');
                });
            });

            name.textContent = shippingOption.fullName || '';
            addressLineOne.textContent = shippingOption.addressLine1 || '';
            addressLineTwo.textContent = shippingOption.addressLine2 || '';
            city.textContent = `${shippingOption.city || ''},` || '';
            state.textContent = `${stateID?.name || ''},` || '';
            zip.textContent = shippingOption.zip || '';
            country.textContent = countryID?.name || '';

            addressWrap.insertBefore(templateEl, addressWrap.lastElementChild);
        }
    }
    const newAddressBtn = document.querySelector('#new-address') as HTMLElement;

    newAddressBtn.addEventListener('click', () => {
        void shippingFunctions.PromptNew(sess).then(resp => drawAddresses([resp]));
    });

    void drawAddresses(shippingOptions);

    //  PAYMENT METHODS
    const paymentOptions = await paymentmethods.GetPaymentOptions({
        'data': 'fullName,company,addressLine1,addressLine2,city,stateID,zip,countryID,phone,email,creditCardFirst6,creditCardLast4,creditCardExpirationDate,key,paymentOptionTypeID,bankType,accountType',
        'sort': 'created asc',
        'q': 'has:email has:phone has:fullName has:addressLine1 has:city has:countryID has:zip valid:yes',
    });

    function drawPaymentMethods(paymentOptions: models.PaymentOption[]) {
        const paymentWrap = document.querySelector('#payment-methods-container') as HTMLElement;

        for (const paymentOption of paymentOptions) {
            const templateEl = template.Clone(document.querySelector('#payment-method-template') as HTMLTemplateElement);
            const templateElChild = templateEl.querySelector('#payment-elements') as HTMLElement;

            const paymentIcon = templateEl.querySelector('#payment-method-icon') as HTMLElement;
            const paymentMethodType = templateEl.querySelector('#payment-method-type') as HTMLElement;
            const lastFour = templateEl.querySelector('#last-four') as HTMLElement;
            const expiration = templateEl.querySelector('#expiration') as HTMLElement;
            const deletePaymentMethodBtn = templateEl.querySelector('#delete-payment-method') as HTMLElement;

            deletePaymentMethodBtn.addEventListener('click', () => {
                void paymentmethods.DeletePaymentOption(paymentOption.id || '').then(() => {
                    templateElChild.parentElement?.removeChild(templateElChild);
                    toast.Success('Removed Payment Method');
                });
            });

            if (paymentOption.paymentOptionTypeID === models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_BANK) {
                paymentMethodType.textContent = 'Bank';
                paymentIcon.classList.add('fas', 'fa-money-check');
            }
            if (paymentOption.paymentOptionTypeID === models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT) {
                paymentMethodType.textContent = 'Card';
                paymentIcon.classList.add('fas', 'fa-credit-card');
            }
            lastFour.textContent = `Ending in: ${paymentOption.creditCardLast4?.toString() || ''}` || '';
            expiration.textContent = `Expires: ${paymentOption.creditCardExpirationDate || ''}` || '';

            paymentWrap.insertBefore(templateEl, paymentWrap.lastElementChild);
        }
    }
    const newPaymentMethodBtn = document.querySelector('#new-payment-method') as HTMLElement;

    newPaymentMethodBtn.addEventListener('click', () => {
        void PromptNewPaymentOption(sess, 'Add payment method', [models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT, models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_BANK]).then(resp => drawPaymentMethods([resp]));
    });

    drawPaymentMethods(paymentOptions);
}